import useCommonStore from '@/stores/pure/CommonStore';

const useAppInit = () => useCommonStore((state) => state.appInit);
export default useAppInit;
